import { createAction, props } from '@ngrx/store';
import { ResponseCigo, RequestCigo } from '../../shared/interfaces';
import { CIGOTypes } from '../../shared/enums';


export const getCigo = createAction(
    CIGOTypes.CIGO,
    props<{ request: RequestCigo}>()
);

export const getCigoSucess = createAction(
    CIGOTypes.CIGO_SUCCESS,
    props<{ response: ResponseCigo }>()
);

export const getCigoError = createAction(
    CIGOTypes.CIGO_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    CIGOTypes.CLEAN_STATE
);
